export const PAYPAL_TAB = "paypal"
export const STRIPE_TAB = "stripe"
